import { IWebsiteAboutUs } from '../../api-response/auth/website-builder';
import { WebsiteBuilderItemWelcomeMessage } from './website-builder-item-welcome-message';

export class WebsiteBuilderItemAbout extends WebsiteBuilderItemWelcomeMessage {
    name = 'About Us';
    navName = 'About Us';
    navLink = 'aboutUs';
    isShowInMenu = false;
    isHomePagePart = true;

    imageUrl: string = '';

    set value(item: IWebsiteAboutUs) {
        this.isPresent = item.status;
        this.headline = item.headlineText || '';
        this.text = item.mainText || '';
        this.imageUrl = item.imageUrl || '';
        this.priority = item.priority;
    }

    get value(): IWebsiteAboutUs {
        return {
            headlineText: this.headline,
            mainText: this.text,
            imageUrl: this.imageUrl,
            status: this.isPresent,
            priority: this.priority
        };
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/website-builder/items/website-builder-item-about.ts